module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-4@2x.6ebea1f1.jpg";